export default __webpack_public_path__ + "static/media/Tabl_17.2f6823e5.svg";